import { Button, Space } from 'antd';
import React from 'react';

interface Props {
	value?: string;
	onChange?: (key: string) => void;
	values: { key: string; value: string }[];
}

export const CustomButtonSelectItem: React.FC<Props> = ({ value, onChange, values }) => (
	<Space wrap>
		{values.map(({ key, value: label }) => (
			<Button
				shape="round"
				key={key}
				onClick={() => onChange?.(key)}
				type={value === key ? 'primary' : 'default'}
				size="large"
			>
				{label}
			</Button>
		))}
	</Space>
);
